import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html'
})
export class AppComponent implements OnInit {
    ngOnInit(): void {
        //this.router.navigate(['fail']);

    }

    constructor(private router: Router, public translate: TranslateService) {
        translate.setDefaultLang('pl');
    }
}